import { useTranslation } from 'react-i18next'

import ErrorAlertIcon from '@/assets/icons/error-alert.svg'
import { ChatBubble } from '@/components/Consultation/steps/Answer/ChatBubble'
import { LoadingDots } from '@/components/icons/LoadingDots'
import { useConsultation } from '@/hooks/useConsultation'
import { useTheme } from '@/hooks/useTheme'
import { IndicationFileStatus } from '@/types/consultation'

import { Divider } from './Divider'

export const Download = () => {
  const { t } = useTranslation()
  const { theme } = useTheme()
  const { consultation } = useConsultation()

  const consultationPdf = consultation?.caseConsultationPdf

  if (!consultationPdf) return null

  const { status } = consultationPdf

  return (
    <ChatBubble containerClassName="flex flex-col gap-6 animate-fade-in items-center p-6">
      {status === IndicationFileStatus.CREATED ? (
        <>
          <div className="flex w-full gap-3">
            <img src={theme?.logo} alt="Logo" className="mx-auto h-12" />

            <div className="flex grow flex-col gap-1">
              <p className="font-bold">{t('sanofi.liver_health_survey')}</p>
              <p>{t('sanofi.professional_assessment')}</p>
            </div>
          </div>

          <Divider />

          <button
            className="text-sm font-bold uppercase text-primary"
            onClick={() => {
              if (status !== IndicationFileStatus.CREATED) return
              window.open(consultationPdf.url, '_blank')
            }}
          >
            {t('download')}
          </button>
        </>
      ) : status === IndicationFileStatus.ERROR ? (
        <>
          <div className="flex items-center gap-4">
            <img src={ErrorAlertIcon} alt="Error" className="mx-auto h-9" />

            <p className="grow text-center font-bold">{t('sanofi.download.error')}</p>
          </div>

          <Divider />

          <p className="text-center" dangerouslySetInnerHTML={{ __html: t('sanofi.download.contact')! }} />
        </>
      ) : status === IndicationFileStatus.CREATING ? (
        <>
          <div className="flex w-full flex-col gap-2">
            <p className="text-center font-bold">{t('sanofi.download.summary_getting_ready')}</p>
            <p className="text-center">{t('sanofi.download.usually_takes')}</p>
          </div>

          <Divider />

          <LoadingDots customClassName="text-primary h-10" />
        </>
      ) : null}
    </ChatBubble>
  )
}
